import cn from 'classnames';
import { Row, WhiteBlock } from "../../../../components/Basic/Blocks";
import { getProviderNew } from '../../../../utils';
import styles from './styles.module.scss';





function SummaryBlock({ providersIdInShipment, provider, allProviders, ...props }) {
    return (
        <WhiteBlock style={props.styles} title="Сводка" left={true} minimize={true} openBlock={false}>
            <Row style={{ width: '80%', justifyContent: 'space-between', position: 'relative', bottom: '52px', left: '100px' }}>
                <div style={{ color: '#353535ad', fontWeight: '700', }} >{`Нет в нал.: ${providersIdInShipment.reduce((acc, p) => { return acc + p.count_not_aval }, 0) || 0} / 
              Резерв: ${providersIdInShipment.reduce((acc, p) => { return acc + p.count_reserve }, 0) || 0} /
              Расхожд.: ${providersIdInShipment.reduce((acc, p) => { return acc + p.count_discr }, 0) || 0} /
               ${providersIdInShipment.reduce((acc, p) => { return acc + p.count_discr + p.count_reserve + p.count_not_aval }, 0) || 0}
              `}</div>
            </Row>
            <table style={{ boxShadow: '2px 2px 2px rgba(109, 109, 109, 0.42)' }} className={styles.table_stat}>
                <thead>
                    <tr>
                        <th
                            style={{ cursor: 'pointer' }}
                            className={styles.td_select}
                            onClick={() => {
                                changeProvider({ name: 'Не выбран', id: null });
                            }}
                        >
                            Поставщик
                        </th>
                        <th>Всего</th>
                        <th>Пропикано</th>
                        <th>Не пропикано</th>

                    </tr>
                </thead>
                <tbody>
                    {providersIdInShipment
                        .sort((a, b) => b.count_not_printed - a.count_not_printed)

                        .map((p) => {
                            return (
                                <tr key={p._id}>
                                    <td
                                        style={{
                                            cursor: 'pointer',
                                            width: '130px',
                                        }}
                                        className={cn(
                                            p._id === provider.id && styles.active,
                                            styles.td_select_transparent,
                                        )}
                                        onClick={() => {
                                            changeProvider({ name: getProviderNew(p._id, allProviders)?.name, id: p._id });
                                        }}
                                    >
                                        {getProviderNew(p._id, allProviders)?.name}
                                    </td>
                                    <td>{p.count_all}</td>
                                    <td>{p.count_printed}</td>
                                    <td>
                                        {`${p.count_not_printed} ( `}
                                        <span style={{ color: '#f41e1ee4' }}>{p.count_not_aval} / </span>
                                        <span style={{ color: '#2cb100e4' }}>{p.count_reserve} / </span>
                                        <span style={{ color: '#f18b55e4' }}>{p.count_discr} </span>
                                        {` )`}
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </WhiteBlock>
    )
}

export default SummaryBlock